import React, { PureComponent, ReactNode } from 'react'
import './PermitLink.scss'
import { LinkContainer } from 'react-router-bootstrap'
import { Button } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import { IPermit } from '../../StrapiService'
import SanitizeHTML from '../SanitizeHTML'
import { TFunction } from 'i18next'

interface Props {
  permit: IPermit
  smallerButtons?: boolean
  t: TFunction;
}

class PermitLink extends PureComponent<Props> {
  render(): ReactNode {
    return (
      <LinkContainer to={`/permits/${this.props.permit.permitId}`} className="permit-link d-flex align-items-center">
        <div>
          <img src={process.env.PUBLIC_URL + this.props.permit.iconUrl} />
          <span className="permit-number">{this.props.permit.permitId}</span>
          <section className="flex-grow-1">
            <h3 className="mb-0">{this.props.permit.title}</h3>
            <SanitizeHTML html={this.props.permit.description} />
          </section>
          <div className={`buttons d-flex${ this.props.permit.reportUrl ? ' wrap' : ''}`}>
            <Link to={`/permits/${this.props.permit.permitId}`} className={`more outline btn-sm btn${this.props.smallerButtons ? ' smaller' : ''}`}>{this.props.t("permits.more")}</Link>
            {
              this.props.permit.downloadUrl &&
              <Link to={this.props.permit.downloadUrl} className={`outline btn-sm btn${this.props.smallerButtons ? ' smaller' : ''}`}>{this.props.t("permits.download")}</Link>
            }
            {
              this.props.permit.reportUrl &&
              <>
                <div className="break"></div>
                <Link to={this.props.permit.reportUrl} className={`outline btn-sm btn${this.props.smallerButtons ? ' smaller' : ''}`}>{this.props.t("permits.report")}</Link>
              </>
            }
            <Link to={this.props.permit.orderUrl} className={`btn-sm btn${this.props.smallerButtons ? ' smaller' : ''}`}>{this.props.t("permits.book")}</Link>
          </div>
        </div>
      </LinkContainer>
    )
  }
}

export default PermitLink
